import { Component } from '@angular/core';

@Component({
    selector: 'app-logoutfreshdesk',
    templateUrl: './logoutfreshdesk.component.html',
    styleUrls: ['./logoutfreshdesk.component.scss'],
    standalone: false
})
export class LogoutfreshdeskComponent {

  constructor() { }
}
